import { DateTime } from 'luxon';

export class AuthLastActivityUpdatedEvent {
  constructor(public lastActivity: DateTime) {}
}
